//
//
//
//
//
//
//
//
//
//

import { searchElements } from '@motionelements/core/src/api/search.js';

export default {
  name: 'SimilarProductsRecommendations',
  components: {
    ProductsGridInfinite: () => import('@motionelements/catalog/src/modules/product/sections/recommendations/ProductsGridInfinite.vue'),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    recommendationType: {
      type: String,
      required: true,
    },
    perPage: {
      type: Number,
      default: 20,
    },
    isProduct2025: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infiniteScrollEvent: null,
      products: [],
      page: 1,
      totalCount: null,
    };
  },
  computed: {
    recommendationKey() {
      switch (this.recommendationType) {
        case 'sameArtist':
          return 'artist';
        case 'samePlugin':
          return 'plugin';
        default:
          return 'similar';
      }
    },
    recommendationValue() {
      switch (this.recommendationType) {
        case 'sameArtist':
          return this.product.artist.username;
        case 'samePlugin':
          return this.recommendPlugin.code.toLowerCase();
        default:
          return this.product.id;
      }
    },
    recommendPlugin() {
      try {
        if (this.product.mediaType === 'ae_template') {
          const plugins = _.get(this.product, 'mediaTypeDetails.pluginsRequired');

          if (plugins && plugins.length) {
            // look for Element 3D

            const plugin = plugins.find(x => x.code.toLowerCase() === 'videocopilot_3darray');

            if (plugin) {
              return plugin;
            }
          }
        }
      } catch (e) {
        // eat errors
        console.error(e);
      }
      return null;
    },
  },
  watch: {
    recommendationType() {
      this.products = [];
      this.totalCount = null;
      if (this.infiniteScrollEvent) {
        this.infiniteScrollEvent.reset();
      }
      this.page = 1;
    },
    product: {
      handler() {
        this.products = [];
        if (this.infiniteScrollEvent) {
          this.infiniteScrollEvent.reset();
        }
        this.page = 1;
      },
      deep: true,
    },
  },
  methods: {
    // getProducts(e) {
    //   this.infiniteScrollEvent = e;
    //   searchElements(this.product.mediaType, {
    //     perPage: this.perPage,
    //     page: this.page,
    //     [this.recommendationKey]: this.recommendationValue,
    //   })
    //     .then(({ data: { data } }) => {
    //       if (data.length) {
    //         this.page += 1;
    //         this.products.push(...data);
    //         this.infiniteScrollEvent.loaded();
    //       } else {
    //         // MP-1397 NEED LOADED THEN COMPLETE WHEN MUSIC COLLECTION LESS ITEM
    //         this.infiniteScrollEvent.loaded();
    //         this.infiniteScrollEvent.complete();
    //       }
    //     }).catch(() => {
    //       this.$rollbar.error('infinite scroll error');
    //       $infiniteScrollState.error();
    //     });
    // },
    getElements() {
      return searchElements(this.product.mediaType, {
        perPage: this.perPage,
        page: this.page,
        [this.recommendationKey]: this.recommendationValue,
      });
    },
    loadMoreProducts($infiniteScrollState) {
      if (Array.isArray(this.products)
        && this.products.length === this.totalCount) {
        // skip loading request if already totalCount
        $infiniteScrollState.loaded();
        $infiniteScrollState.complete();
        return;
      }

      this.getElements().then(({ data: { data, totalCount } }) => {
        this.totalCount = totalCount;
        if (data.length) {
          this.page += 1;
          this.products.push(...data);
          setTimeout(() => {
            $infiniteScrollState.loaded();
          }, 500);
        } else {
          // MP-1397 NEED LOADED THEN COMPLETE WHEN MUSIC COLLECTION LESS ITEM
          // this.infiniteScrollEvent.loaded();
          $infiniteScrollState.complete();
        }
      }).catch(() => {
        this.$rollbar.error('infinite scroll error');
        $infiniteScrollState.error();
      });
    },
  },
};
